import React from 'react';
import { MaxusPremium } from '.';
import DatePicker, { registerLocale } from 'react-datepicker';
import styled from 'styled-components';
import sv from 'date-fns/locale/sv';
import 'react-datepicker/dist/react-datepicker.css';
import '../styles/datepicker-fix.css';

import MaxusLogo from '../images/maxus_logo.png';
import { MaxusFooter, MaxusHeader } from '.';
import LinLogo from '../images/lin_logo.png';

registerLocale('sv', sv);

function WizardStart(props) {
  if (props.warn) {
    return null;
  }

  return (
    <p>
      Fyll i dina uppgifter i formuläret till vänster och klicka på &nbsp;
      <strong>”Se ditt pris”</strong>
      &nbsp; för att komma vidare.
    </p>
  );
}

function ErrorText(props) {
  return (
    <div>
      <h2>Ajdå!</h2>
      <p>
        Tyvärr kan vi inte ge dig ett konkurrenskraftigt pris för försäkring på
        den här bilen. Vårt råd är därför att du kontaktar andra
        försäkringsbolag.
      </p>
      <p>
        Det kan finnas flera anledningar till varför du inte får ett pris av
        oss. Bland annat kan det bero på att:
      </p>
      <ul>
        <li>du är under 30 år eller inte haft körtkort så länge</li>
        <li>bilen är för hög</li>
        <li>bilen har för många hästkrafter</li>
        <li>vi saknar teknisk information om bilen</li>
      </ul>
      <p>
        Vid frågor vänligen kontakta oss på{' '}
        <a href='mailto:info@linforsakring.se'>info@linforsakring.se</a> eller
        via vår chatt – se längst ner i högra hörnet på{' '}
        <a href='https://linforsakring.se'>linforsakring.se</a>.
      </p>
      <button
        type='button'
        className='green-btn'
        onClick={() => props.handleClick()}
      >
        Tillbaka
      </button>
    </div>
  );
}

export default class QuoteForm extends React.Component {
  constructor(props) {
    super(props);
    var initialStartDate = new Date();
    var initialEndDate = new Date(initialStartDate);
    initialEndDate.setDate(initialEndDate.getDate() + 59);
    this.state = {
      regNumber: '',
      socialSecurity: '',
      makeModel: '',
      monthlyPremium: '',
      coverLevel: 'Halv',
      dwelling: 'Villa',
      firstName: '',
      lastName: '',
      fullName: '',
      excessLevel: '4000',
      mileage: '0-1000',
      isError: false,
      isLoading: false,
      hasCalculationResult: null,
      begun: false,
      quoteId: '',
      telephoneNumber: '',
      email: '',
      startDate: initialStartDate,
      endDate: initialEndDate,
      youngDriver: 'Nej',
      optHiredCar: false,
      optAnimalCollision: false,
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  handleChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;
    this.setState({
      [name]: value,
    });
  }

  handleDateChange = date => {
    var newEndDate = new Date(date);
    newEndDate.setDate(newEndDate.getDate() + 59);
    console.log(newEndDate);

    this.setState({
      startDate: date,
      endDate: newEndDate 
    });
  };

  handleBackToFormClick = event => {
    this.setState({ hasCalculationResult: null, isError: false });
  };

  handleSubmit(event) {
    event.preventDefault();

    window.scrollTo(0, 0);

    this.setState({ isLoading: true, hasCalculationResult: false });
    fetch(process.env.REACT_APP_KRAKEN_URL + '/quote', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Access-Control-Request-Method': 'POST',
      },
      body: JSON.stringify({
        registrationNumber: this.state.regNumber,
        socialSecurity: this.state.socialSecurity,
        coverLevel: this.state.coverLevel,
        dwelling: this.state.dwelling,
        mileage: this.state.mileage,
        excessLevel: this.state.excessLevel,
        startDate: this.state.startDate.toLocaleDateString('sv-SE'),
        endDate: this.state.endDate.toLocaleDateString('sv-SE'),
        telephoneNumber: this.state.telephoneNumber,
        email: this.state.email,
        youngDriver: this.state.youngDriver === 'Ja' ? 'Ja' : 'Nej',
        optHiredCar: this.state.optHiredCar === 'Ja' ? 'true' : 'false',
        optAnimalCollision:
          this.state.optAnimalCollision === 'Ja' ? 'true' : 'false',
        reference: 'osa',
        paymentMethod: 'Monthly',
        product: 'maxus-trial-motor',
        productVersion: 'latest',
        parking: 'Egen tomt',
        claimFreeYears: '2',
      }),
    })
      .then(response => {
        console.log(response);
        return response.json();
      })
      .then(json => {
        console.log(json);
        this.setState({
          makeModel: json.carMake,
          monthlyPremium: Math.floor(json.premium.monthly),
          firstName: json.firstName,
          lastName: json.lastName,
          fullName: json.firstName + ' ' + json.lastName,
          quoteId: json.id,
        });
        this.setState({
          hasCalculationResult: true,
          isLoading: false,
          isError: false,
          begin: true,
        });
      })
      .catch(error => {
        console.warn(error);
        this.setState({
          isError: true,
          isLoading: false,
          hasCalculationResult: false,
        });
      });
  }
  shouldRefreshPremium(state) {
    console.log('state.hasCalculationResult: ', state.hasCalculationResult);

    return (
      state.hasCalculationResult === null ||
      state.hasCalculationResult === false
    );
  }

  render() {
    return (
      <>
        <main>
          <section
            className={
              'form-section ' +
              (this.state.hasCalculationResult !== null ? 'success' : '')
            }
          >
            <aside className='form-sidebar'>
              <h2>Ditt Pris</h2>
              <div className='sidebar-info'>
                {this.state.hasCalculationResult === null ? (
                  <WizardStart warn={this.state.begun}></WizardStart>
                ) : (
                  <div></div>
                )}
              </div>
              {this.shouldRefreshPremium(this.state) ? (
                <div></div>
              ) : (
                <MaxusPremium
                  fullName={this.state.fullName}
                  makeModel={this.state.makeModel}
                  premium={this.state.monthlyPremium}
                  quoteId={this.state.quoteId}
                />
              )}
              {this.state.isError ? (
                <ErrorText handleClick={this.handleBackToFormClick}></ErrorText>
              ) : (
                <div></div>
              )}
            </aside>
            <div className='form-wrap'>
              <div className='form-section__container'>
                <form className='insurance-form' onSubmit={this.handleSubmit}>
                  <header className='insurance-form__header'>
                    <LogoContainer>
                      <img src={MaxusLogo} alt='Maxus' />
                      <img src={LinLogo} alt='lin försäkring' />
                    </LogoContainer>
                    <h1>Teckna försäkring</h1>
                  </header>
                  <div className='insurance-form__body'>
                    <div className='insurance-form__col'>
                      <label htmlFor='personal'>Personnummer</label>
                      <input
                        className='input-field'
                        type='text'
                        name='socialSecurity'
                        value={this.state.socialSecurity}
                        onChange={this.handleChange}
                        maxLength='10'
                        minLength='10'
                        pattern='\d*'
                        id='personal'
                        placeholder='ÅÅMMDDXXXX'
                        required
                      />
                    </div>
                    <div className='insurance-form__col'>
                      <label htmlFor='registration'>Registreringsnummer</label>
                      <input
                        className='input-field'
                        type='text'
                        name='regNumber'
                        value={this.state.regNumber}
                        onChange={this.handleChange}
                        maxLength='6'
                        minLength='6'
                        id='registration'
                        placeholder='ABC123'
                        required
                      />
                    </div>
                    <div className='insurance-form__col'>
                      <label htmlFor='traffic'>Välj omfattning</label>
                      <div className='select-wrap'>
                        <select
                          className='input-field'
                          name='coverLevel'
                          value={this.state.coverLevel}
                          onChange={this.handleChange}
                          id='traffic'
                        >
                          <option value='Halv'>Halv</option>
                          <option value='Hel'>Hel</option>
                        </select>
                      </div>
                    </div>
                    <div className='insurance-form__col'>
                      <label htmlFor='accommodation'>Boende</label>
                      <div className='select-wrap'>
                        <select
                          name='dwelling'
                          value={this.state.dwelling}
                          onChange={this.handleChange}
                          id='accommodation'
                        >
                          <option value='Villa'>Villa</option>
                          <option value='Lägenhet - hyresrätt'>
                            Lägenhet - hyresrätt
                        </option>
                          <option value='Lägenhet - bostadsrätt'>
                            Lägenhet - bostadsrätt
                        </option>
                        </select>
                      </div>
                    </div>
                    <div className='insurance-form__col'>
                      <label htmlFor='cover'>
                        Uppskattad körsträcka (mil/år)
                    </label>
                      <div className='select-wrap'>
                        <select
                          name='mileage'
                          value={this.state.mileage}
                          onChange={this.handleChange}
                          id='cover'
                        >
                          <option>0-1000</option>
                          <option>1001-1200</option>
                          <option>1201-1500</option>
                          <option>1501-2000</option>
                          <option>2001-2500</option>
                          <option>2501-3000</option>
                          <option>3001-4000</option>
                          <option>4000+</option>
                        </select>
                      </div>
                    </div>
                    <div className='insurance-form__col'>
                      <label htmlFor='self-risk-damage'>
                        Självrisk vagnskada
                    </label>
                      <div className='select-wrap'>
                        <select
                          name='excessLevel'
                          value={this.state.excessLevel}
                          onChange={this.handleChange}
                          id='excessLevel'
                        >
                          <option value='4000'>4000</option>
                          <option value='8000'>8000</option>
                          <option value='16000'>16000</option>
                        </select>
                      </div>
                    </div>
                    <div className='insurance-form__col'>
                      <label htmlFor='telephoneNumberinputid'>Mobilnummer</label>
                      <input
                        className='input-field'
                        type='text'
                        name='telephoneNumber'
                        value={this.state.telephoneNumber}
                        onChange={this.handleChange}
                        maxLength='10'
                        minLength='10'
                        pattern='(07)\d*'
                        id='telephoneNumberinputid'
                        placeholder='07XXXXXXXX'
                        required
                      />
                    </div>
                    <div className='insurance-form__col'>
                      <label htmlFor='emailinputid'>Email</label>
                      <input
                        className='input-field'
                        type='text'
                        name='email'
                        value={this.state.email}
                        onChange={this.handleChange}
                        id='emailinputid'
                        placeholder='email@email.se'
                        required
                      />
                    </div>
                    <div className='insurance-form__col'>
                      <label htmlFor='startdayinput'>Startdatum</label>
                      <DatePicker
                        locale='sv'
                        className='input-field'
                        id='startdayinput'
                        name='startDay'
                        dateFormat='yyyy/MM/dd'
                        onChange={this.handleDateChange}
                        value={this.state.startDate}
                        selected={this.state.startDate}
                        required
                        minDate={new Date()}
                      />
                    </div>
                    <div className='insurance-form__col'>
                      <label htmlFor='emailinputid'>
                        F&ouml;rare under 25 &aring;r?
                    </label>
                      <select
                        value={this.state.youngDriver}
                        onChange={this.handleChange}
                        name='youngDriver'
                      >
                        <option value='Nej'>Nej</option>
                        <option value='Ja'>Ja</option>
                      </select>
                    </div>
                    <div className='insurance-form__col'>
                      <label htmlFor='hiredcarselect'>Hyrbil?</label>
                      <select
                        value={this.state.hiredCar}
                        onChange={this.handleChange}
                        name='optHiredCar'
                        id='hiredcarselect'
                      >
                        <option value='Nej'>Nej</option>
                        <option value='Ja'>Ja</option>
                      </select>
                    </div>
                    <div className='insurance-form__col'>
                      <label htmlFor='animalcollisionselect'>
                        Djurkollision?
                    </label>
                      <select
                        value={this.state.animalCollision}
                        onChange={this.handleChange}
                        name='optAnimalCollision'
                        id='animalcollisionselect'
                      >
                        <option value='Nej'>Nej</option>
                        <option value='Ja'>Ja</option>
                      </select>
                    </div>
                  </div>
                  <div className='insurance-form__footer'>
                    <div className='insurance-form__info'>
                      <p>
                        Läs om vår hantering av{' '}
                        <a
                          href='https://www.maxusforsakring.se/integritetspolicy'
                          target='_blank'
                          rel='noopener noreferrer'
                        >
                          personuppgifter
                      </a>
                      </p>
                    </div>
                    <div className='insurance-form__btn-holder'>
                      <button
                        type='submit'
                        disabled={this.state.isLoading}
                        className='blue-sign-btn'
                      >
                        Se ditt pris
                    </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </section>
        </main>
        <MaxusFooter />
      </>
    );
  }
}

const LogoContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  margin-bottom: 3rem;

  img {
    max-height: 56px;
    margin: 0 1.5rem;
  }
`;
